import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useOutletContext } from 'react-router-dom'

import { PageSection } from '@ui/components/PageSection'

import { Operator, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { AccountGroupType } from '@model/AccountGroupType'
import { PlatformTypeEnum } from '@model/PlatformTypeEnum'

import { useFetchOne } from '@hooks/useFetch'
import { ScrollToIds } from '@hooks/useScrollToElementIds'

import { Loading } from '@shared/components/Loading/Loading'

type ContextType = { tradingAccountId?: string }

export const StatementsETD: React.FC = () => {
  const { t } = useTranslation()
  const apiClient = useApiClient(ClientApiClient)

  const tradingAccountCallback = useCallback(async () => {
    const [tradingAccount] = (
      await apiClient.getTradingAccounts({
        search: {
          AccountGroupType: {
            value: AccountGroupType.Live,
            operator: Operator.EQUAL,
          },
          Platform: {
            value: PlatformTypeEnum.CQGCAST, // it's for ETD
            operator: Operator.EQUAL,
          },
          Status: {
            value: 1,
            operator: Operator.EQUAL,
          },
        },
      })
    ).items

    return tradingAccount?.id
  }, [apiClient])

  const { data: tradingAccountId, isLoading } = useFetchOne(tradingAccountCallback)

  return (
    <>
      <PageSection
        title={t('Tabs.Statements')}
        tabData={{
          tabs: [
            { path: 'daily', label: t('Statements.Daily') },
            { path: 'monthly', label: t('Statements.Monthly') },
          ],
        }}
        id={ScrollToIds.StatementsETDHeader}
      />
      <Loading showLoadingIcon isLoading={isLoading}>
        <Outlet context={{ tradingAccountId } satisfies ContextType} />
      </Loading>
    </>
  )
}

export const useStatementsTAId = (): ContextType => {
  return useOutletContext<ContextType>()
}
